import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import MuiPagination from "../../shares/MuiPagination";
import useFetch from "../../../context/useFetch";
import { useCustomerBasket } from "../../../context/CustomerBasketContext";
import { useUserData } from "../../../context/UserDataContext";
import PanelTable from "../../shares/PanelTable";
import ShowRingSizes from "./ShowRingSizes";
import AddRingTabThree from "./AddRingTabThree";
import PanelFilter from "../../shares/PanelFilter";
import { fixNumbers } from "../../../utils";

// import Others files

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "add_ring", name: "افزودن" },
];
const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const TabThree = (props) => {
  const { userSelectedRing } = useCustomerBasket();
  const [openRingsSizeShowModal, setOpenRingsSizeShowModal] = useState(false);
  const [openAddOrderModal, setOpenAddOrderModal] = useState(false);

  const { userData } = useUserData();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 3000,
    count: 0,
  });
  const [codeFilter, setCodeFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const filterList = [
    {
      type: "textField",
      label_fa: "کد النگو",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام النگو",
      label_en: "name",
      state: nameFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",

      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];
  const [ringsList, setRingsList] = useState({ results: [] });
  const GetRingsApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/user_get_order_item_history`,
    pagination: paginationPageInfo,
    params: {
      code: fixNumbers(codeFilter),
      brand: brandFilter == "all" ? null : brandFilter,
      name: nameFilter,
    },
    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      // setPageData(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRingsList({ results: [] });

    GetRingsApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
  ];
  const actionsList = [
    {
      label: "افزودن",
      component: (it) => <AddRingTabThree selectedRow={it} />,
    },
  ];
  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);
  };
  const filter = () => {
    if (codeFilter !== null || nameFilter !== null || brandFilter !== null) {
      setRingsList({ results: [] });

      GetRingsApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setNameFilter(null);
    setBrandFilter(null);
    GetRingsApi.reFetch();
  };
  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <PanelTable
        header="خریدهای قبلی:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={ringsList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      {/* <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      /> */}
    </>
  );
};

export default TabThree;
